import { Injectable } from "@angular/core";
import { CommonHttpModule } from "../../providers/commonHttpModule";
import { map, Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})

export class FdaService {
    constructor(private http: CommonHttpModule) {

    }

    fdaWithoutPda(data: any): Observable<any> {
        return this.http.post("fda_creation_without_pda", data).pipe(
            map((response) => {
                return response;
            })
        )
    }
    fdaWithPda(data: any): Observable<any> {
        return this.http.post("fda_creation_with_pda", data).pipe(
            map((response) => {
                return response;
            })
        )
    }

    fdaDisbursementList(): Observable<any> {
        return this.http.get("list_of_disbursement_id", {}).pipe(
            map((response) => {
                return response
            })
        )
    }

    getDisbursementDetails(disbursementSeq: number): Observable<any> {
        return this.http.get(`get_port_agent_data_by_disbursement_seq/${disbursementSeq}`, {}).pipe(
            map((response) => {
                return response;
            })
        );
    }

    fdaReCalculate(data: any): Observable<any> {
        return this.http.post(`calculation`, data).pipe(
            map((response) => {
                return response;
            })
        );
    }

    fdaSaveAndSubmit(data: any): Observable<any> {
        return this.http.post('fda_edit', data).pipe(
            map((response) => {
                return response;
            })
        )
    }
}